import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const AddCourse = () => {
  const [courseOptions, setCourseOptions] = useState({});
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [resourceLink, setResourceLink] = useState("");
  const [rate, setRate] = useState("");
  const [toast, setToast] = useState({ message: "", show: false });

  const navigate = useNavigate();
  const levels = Object.keys(courseOptions);

  const showToast = (message) => {
    setToast({ message, show: true });
    setTimeout(() => setToast({ message: "", show: false }), 3000);
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch("http://193.123.94.90/get-course-options", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          const data = await response.json();
          setCourseOptions(data);
        } else {
          showToast("❌ Failed to fetch course options.");
        }
      } catch (err) {
        console.error("Error fetching course options:", err);
        showToast("🚫 An error occurred while loading courses.");
      }
    };

    fetchOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await fetch("http://193.123.94.90/add-course", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          level: selectedLevel,
          course: selectedCourse,
          resource: resourceLink,
          rate: rate,
        }),
      });

      if (response.ok) {
        showToast("✅ Course added successfully!");
        setTimeout(() => navigate("/profile/teacher"), 1000);
      } else {
        showToast("⚠️ Failed to add course.");
      }
    } catch (error) {
      console.error("Error submitting course:", error);
      showToast("🚫 You are already teaching this course.");
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ backgroundColor: "#ffeae9", position: 'relative' }}
    >
      {/* Toast */}
      {toast.show && (
        <div
          className="position-absolute top-0 start-50 translate-middle-x mt-3 px-4 py-2 rounded shadow"
          style={{
            backgroundColor: "#fff0f0",
            color: "#c03b3b",
            zIndex: 1000,
            border: "1px solid #f5b5b5",
          }}
        >
          {toast.message}
        </div>
      )}

      {/* Background Image */}
      <div
        style={{
          backgroundImage: 'url("/background.jpg")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          opacity: 0.15,
          position: 'absolute',
          inset: 0,
          zIndex: 0,
        }}
      ></div>

      <div className="bg-white rounded-4 shadow p-5 w-100" style={{ maxWidth: "500px", zIndex: 1 }}>
        <button
          className="btn btn-outline-secondary mb-3"
          onClick={() => navigate("/profile/teacher")}
        >
          ← Back to Profile
        </button>

        <h2 className="text-center mb-4">Add a New Course</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="level" className="form-label">Select Level</label>
            <select
              id="level"
              className="form-select"
              value={selectedLevel}
              onChange={(e) => {
                setSelectedLevel(e.target.value);
                setSelectedCourse("");
              }}
              required
            >
              <option value="">-- Select Level --</option>
              {levels.map((lvl, idx) => (
                <option key={idx} value={lvl}>{lvl}</option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="course" className="form-label">Select Course</label>
            <select
              id="course"
              className="form-select"
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
              required
              disabled={!selectedLevel}
            >
              <option value="">-- Select Course --</option>
              {selectedLevel && courseOptions[selectedLevel]?.map((crs, idx) => (
                <option key={idx} value={crs}>{crs}</option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="rate" className="form-label">Rate (PKR)</label>
            <input
              type="number"
              id="rate"
              className="form-control"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
              placeholder="Enter your rate"
              required
              min={0}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="resource" className="form-label">Google Drive Resource Link</label>
            <input
              type="url"
              id="resource"
              className="form-control"
              value={resourceLink}
              onChange={(e) => setResourceLink(e.target.value)}
              placeholder="https://drive.google.com/..."
              required
            />
          </div>

          <button type="submit" className="btn btn-peach w-100 mt-3">Submit Course</button>
        </form>
      </div>
    </div>
  );
};

export default AddCourse;
